{
  "#TIME_REPORT": {
    "TITLE": "Arbeitsbericht",
    "MENU": {
      "ACTIONS": "Aktionen",
      "LIST": "Arbeitsbericht",
      "QUERY": "Abfrage",
      "QUERY_RESULT": "Ergebnisse",
      "INPUT": "Erfassen"
    },
    "PAGES": {
      "CREATE": {
        "SAVE": "Speichern",
        "SUBTITLE": "Erfassen",
        "REPORT_OVERLINE": "Arbeitsberichte vom"
      },
      "EDIT": {
        "SUBTITLE": "Bearbeiten"
      }
    },
    "COMPONENTS": {
      "OVERVIEW": {
        "TITLE": "Erfassen"
      },
      "INPUT": {
        "SUBMIT": "Speichern",
        "RESET": "Zurücksetzen",
        "SELECT_PARTY": "Partie auswählen"
      },
      "LIST": {
        "TOTAL": "Gesamt",
        "NO_DATA": "An diesem Tag wurden noch keine Zeiten erfasst!"
      },
      "EDIT": {
        "TITLE": "Bearbeiten",
        "SUBMIT": "Speichern",
        "RECORDED_FOR": "Miterfasst für",
        "GEODATEN": "Geodaten",
        "GEO_MAPS_LINK": "Navigation starten",
        "GPS_LAENGE": "Längengrad",
        "GPS_BREITE": "Breitengrad"
      },
      "QUERY": {
        "TITLE": "Arbeitsbericht",
        "SUBTITLE": "Abfrage",
        "SUBMIT": "Abfragen",
        "RESET": "Zurücksetzen",
        "QUICK_LINKS": {
          "TITLE": "Schnellabfrage",
          "CURRENT_WEEK": "Diese Woche",
          "LAST_WEEK": "Letzte Woche",
          "CURRENT_MONTH": "Dieses Monat"
        },
        "MANUAL": "Manuelle Abfrage"
      },
      "QUERY_RESULT": {
        "TITLE": "Arbeitsbericht",
        "SUBTITLE": "Abfrageergebniss",
        "FILTER": "Angewendete Filter"
      }
    },
    "ACTIONS": {
      "TITLE": "Aktionen",
      "EDIT": "Bearbeiten",
      "RECENT_OBJECTS": "Letzte Objekte"
    },
    "FILES": {
      "HEADER": "Bilder"
    },
    "DIALOGS": {
      "PARTY": {
        "TITLE": "Partie auswählen",
        "SELECTED_COUNT_POSTFIX": "ausgewählt",
        "NO_PERSONS_FOUND": "Es konnten keine Personen in Ihrer Abteilung gefunden werden",
        "SAVE": "Speichern"
      },
      "CONFIRM_DELETE": {
        "TITLE": "Eintrag löschen?",
        "DESC": "Soll Arbeitsberichteintrag wirklich gelöscht werden?"
      },
      "RECENT_OBJECTS": {
        "TITLE": "Zuletzt benutzte Objekte",
        "HINT": "Zum Auswählen auf einen Listeneintrag tippen"
      }
    },
    "MESSAGES": {
      "ERROR": {
        "TITLE": "Fehler",
        "LOADING": "Beim Laden des Zeitberichts ist ein Fehler aufgetreten",
        "SAVE": "Der Arbeitsbericht konnte nicht gespeichert werden"
      },
      "SUCCESS": {
        "TITLE": "Erfolgreich",
        "SAVE": "Der Arbeitsbericht wurde gespeichert"
      },
      "SUCCESS_UPDATE": {
        "TITLE": "Änderung erfolgreich gespeichert",
        "SAVE": "Die vorgenommenen Änderungen wurden gespeichert"
      }
    }
  }
}
